import { getStoreName } from './config';

export default formStoreName => {
    const storeName = getStoreName(formStoreName);
    return {
        INCREMENT_ITEMS_TO_SHOW: `${storeName}.INCREMENT_ITEMS_TO_SHOW`,
        RESET_ITEMS_TO_SHOW: `${storeName}.RESET_ITEMS_TO_SHOW`,
        SET_ITEMS_TO_SHOW: `${storeName}.SET_ITEMS_TO_SHOW`,
    };
};
